import { headlines } from "@/mocks/homeData";

export default function HeadlineSection() {
  const [lead, ...rest] = headlines;

  return (
    <section id="headlines" className="w-full border-b border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-shell px-4 py-14 md:px-6 md:py-20 lg:px-8">
        <div className="mb-8 flex flex-wrap items-end justify-between gap-4">
          <div>
            <span className="flex items-center gap-2 font-label text-xs tracking-[0.28em] text-primary-600">
              <i className="ri-fire-line" />
              今日头条
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              今天最值得先看的一条
            </h2>
          </div>
          <a
            href="#updates"
            className="flex cursor-pointer items-center gap-2 whitespace-nowrap font-label text-sm text-foreground-700 transition-colors hover:text-primary-600"
          >
            更多今日动态
            <i className="ri-arrow-right-line" />
          </a>
        </div>

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-12">
          <article className="lg:col-span-7">
            <a href="#top" className="group block cursor-pointer">
              <div className="h-60 w-full overflow-hidden rounded-lg bg-background-200 md:h-80">
                <img
                  src={lead.image}
                  alt="今日头条现场氛围图"
                  title="黑料网1 今日头条 最新更新"
                  className="h-full w-full object-top transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <div className="mt-5 flex flex-wrap items-center gap-3 font-label text-xs text-foreground-500">
                <span className="rounded bg-primary-500 px-2.5 py-1 text-background-50">{lead.tag}</span>
                <span className="flex items-center gap-1">
                  <i className="ri-time-line" />
                  {lead.time}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-eye-line" />
                  {lead.reads}
                </span>
              </div>
              <h3 className="mt-3 font-heading text-xl font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 md:text-2xl">
                {lead.title}
              </h3>
              <p className="mt-3 max-w-2xl font-body text-sm leading-relaxed text-foreground-600 md:text-base">
                {lead.summary}
              </p>
            </a>
          </article>

          <div className="flex flex-col gap-5 lg:col-span-5">
            {rest.map((item) => (
              <article key={item.id}>
                <a
                  href="#top"
                  className="group flex cursor-pointer gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-accent-300 md:p-4"
                >
                  <div className="h-24 w-28 shrink-0 overflow-hidden rounded-md bg-background-200 md:h-28 md:w-36">
                    <img
                      src={item.image}
                      alt={`${item.tag}相关现场图`}
                      title="黑料网1 新料快讯"
                      className="h-full w-full object-top transition-transform duration-700 group-hover:scale-105"
                    />
                  </div>
                  <div className="min-w-0">
                    <span className="font-label text-[11px] tracking-wider text-accent-700">{item.tag}</span>
                    <h3 className="mt-1 line-clamp-2 font-heading text-base font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600">
                      {item.title}
                    </h3>
                    <div className="mt-2 flex flex-wrap items-center gap-3 font-label text-[11px] text-foreground-500">
                      <span>{item.time}</span>
                      <span>{item.reads} 阅读</span>
                    </div>
                  </div>
                </a>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}